import React, { useState, useImperativeHandle, forwardRef } from 'react';

import ReactTable from 'components/ReactTable/ReactTable';
import { DateFilteredTableProps } from '../types';
import DateFilteredComponent from '../dateFiltered/dateFilteredComponent/dateFilteredComponent';

export interface MarkerPaymentsDateFilteredTableRef {
  getTableData: () => any[];
}

const MarkerPaymentsDateFilteredTable = forwardRef<MarkerPaymentsDateFilteredTableRef, DateFilteredTableProps>(({
  fetchMethod,
  columns,
  hasTotal,
}, ref) => {
  const [tableData, setTableData] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    getTableData: () => tableData,
  }));

  return (
    <>
      <div className="filtered-table__container">
        <DateFilteredComponent
          component={[
            <ReactTable
              data={tableData}
              columns={columns}
              topPaginationClassName="table-pagination_top"
              isLastColumnSortable={true}
              hasTotal={hasTotal}
            />]
          }
          fetchMethod={fetchMethod}
          updateDataMethod={setTableData}
          componentName="table"
        />
      </div>
    </>
  );
});

MarkerPaymentsDateFilteredTable.displayName = 'MarkerPaymentsDateFilteredTable';

export default MarkerPaymentsDateFilteredTable;
